import React from 'react'

/* The ContactDetail component displays details about a contact.
Contains a property called contact, which is a map containing contact details
*/
export default class ContactDetail extends React.Component {
  constructor(props){
    super(props)
  }

  render(){
    let contact = this.props.contact;
    if (contact.visible != null) {
      if (contact.visible == false || contact.firstName == null )  {
        console.log("contact visible is false");
        return null;
      }
    }
    let position = contact.position;
    if (position != null){ // we currently receive the position as a string that is uppercase and with underscores instead of spaces, so replace these.
      // position = position.toLowerCase().replace("_", " ");
      position = position.toLowerCase().replace(/_/g, " ");
      position = position.replace(/(^|\s)\S/g, letter => letter.toUpperCase());

    }
    try{
      return (

        <div className="club-contact">
         <div>
           <p className="contact-role">
             {contact.firstName &&
               <span className="bold">{contact.firstName}&nbsp;{(contact.lastName != null) ? contact.lastName : ''}</span>
             }
             
           </p>
           <p>{position}</p>
 
         </div>
         {contact.email &&
            <p><a href={'mailto:' + contact.email} className="contact-link contact-email">{contact.email}</a></p>
          }
          {contact.phone &&
            <p><a href={'tel:' + contact.phone} className="contact-link contact-phone">{contact.phone}</a></p>
          }
       </div>
     )
    } catch(e){
      console.log('Error rendering contact' + e.message)
      return null;
    }
  }
} 
